export default __webpack_public_path__ + "static/media/dropDownArrow.9904eb30.svg";